<template>
  <v-dialog
    :value="true"
    persistent
    max-width="600px"
  >
    <v-card>
      <v-card-title class="pa-4">
        <span class="headline">Verifique o seu celular</span>
      </v-card-title>
      <v-card-text>
        <span class="subline pa-3">
          Confirme o código de 6 dígitos que enviamos para o seu telefone pra continuar
        </span>
        <v-container>
          <v-text-field
            v-model="code"
            v-mask="'######'"
            label="Código"
            placeholder="Digite o código"
          />
        </v-container>
      </v-card-text>
      <v-card-actions>
        <div class="flex-grow-1" />
        <v-btn
          text
          @click="onCancel"
        >
          Cancelar
        </v-btn>
        <v-btn
          color="primary"
          rounded
          large
          @click="onSend({
            code,
            onSuccess,
          })"
        >
          Enviar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import { mask } from 'vue-the-mask';

const verifyPhone = createNamespacedHelpers('views/verifyPhone');
const guestList = createNamespacedHelpers('views/guestList');

export default {
  name: 'VerifyPhone',
  directives: { mask },
  data: () => ({
    phone: '',
    code: null,
  }),
  mounted() {
    this.sendSmsVerification({
      phone: `${this.$parent.$data.phone.replace(/\D/g, '')}`,
    });
  },
  methods: {
    ...verifyPhone.mapMutations([
      'setOverlay',
    ]),
    ...verifyPhone.mapActions([
      'onVerifyPhone',
      'onPhoneVerified',
      'sendSmsVerification',
    ]),
    ...guestList.mapActions([
      'onAddClick',
    ]),
    onSend({
      code, onSuccess,
    }) {
      const verifyData = {
        phone: this.$parent.$data.phone.replace(/\D/g, ''),
        code: code.replace(/\D/g, ''),
      };
      this.onVerifyPhone({
        verifyData, onSuccess,
      });
    },
    onSuccess() {
      this.$emit('phoneVerified');
    },
    onCancel() {
      this.$emit('verifyCancel');
    },
  },

};
</script>
